import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { GrowWrapper, FlexCenterWrapper, FlexCenterBetweenWrapper, FlexCenterJustifyCenterWrapper } from 'wrappers';
import internalState from './internalState';
import { SecondaryTextBase } from 'atoms';
import { AssignmentStatusLabel } from 'molecules';
import { ListWrapper, MobileListWrapper, Wrapper } from './wrappers';
import { format } from 'date-fns';
import { Arrow, TextButton } from './atoms';
import { DragDropAssignments } from 'atoms';
import { labelState } from './utils';
import { LeftArrowSvg, RightArrowSvg } from 'components/icons';
import { AssignmentRow, MobileAssignmentRow } from './molecules';
import { getIsMobile } from 'utils';

const ContainerListWrapper = (props) => {
  return props?.isMobile ? MobileListWrapper : wrap(ListWrapper, GrowWrapper);
}

export const definition = {
  name: "AssignmentsList",
  controller: Controller,
  initialProps: ({
    overviewTabSelectedGraph,
    overviewTabSelectedTimeRangeId,
    group,
    assignmentsGroupIndex,
    groupsCount,
    name,
    image,
  }) => ({
    overviewTabSelectedGraph,
    overviewTabSelectedTimeRangeId,
    group,
    assignmentsGroupIndex,
    groupsCount,
    visibleAssignments: group?.assignments?.slice(0, 6) ?? [],
    name,
    image,
    isMobile: getIsMobile()
  }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(FlexCenterBetweenWrapper, Wrapper),
      name: 'ListHeader',
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'TitleSection',
          elements: [
            {
              component: SecondaryTextBase,
              name: 'Title',
              displayValue: ({ overviewTabSelectedGraph }) => `${overviewTabSelectedGraph.charAt(0).toUpperCase() + overviewTabSelectedGraph.slice(1)} Work orders`
            },
            {
              component: AssignmentStatusLabel,
              renderIf: ({ isMobile }) => !isMobile,
              name: 'Label',
              displayState: ({ overviewTabSelectedGraph }) => labelState(overviewTabSelectedGraph),
              bindings: ({ overviewTabSelectedGraph }) => ({ selectedGraph: overviewTabSelectedGraph, colors: labelState(overviewTabSelectedGraph) })
            }
          ]
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'MonthSelector',
          renderIf: ({ overviewTabSelectedTimeRangeId, group }) => overviewTabSelectedTimeRangeId !== 1 && !!group && !!group.date,
          elements: [
            {
              component: Arrow,
              name: 'LeftArrow',
              displayValue: ({ }) => LeftArrowSvg({}),
              renderIf: ({ assignmentsGroupIndex }) => assignmentsGroupIndex > 0,
              bindings: ({ assignmentsGroupIndex }) => ({ assignmentsGroupIndex })
            },
            {
              component: SecondaryTextBase,
              name: 'Title',
              displayValue: ({ group }) => format(group.date, "MMM yyyy")
            },
            {
              component: Arrow,
              name: 'RightArrow',
              displayValue: ({ }) => RightArrowSvg({}),
              renderIf: ({ assignmentsGroupIndex, groupsCount }) => assignmentsGroupIndex < (groupsCount - 1),
              bindings: ({ assignmentsGroupIndex }) => ({ assignmentsGroupIndex })
            },
          ]
        }
      ]
    },
    {
      wrapperSelect: ContainerListWrapper,
      name: 'ListWrapper',
      elements: [
        {
          component: DragDropAssignments,
          name: 'MutableAssignments',
          renderIf: ({ group, isMobile }) => !isMobile && !!group && group?.assignments?.[0]?.status === 'assigned',
          displayValue: ({ group, name }) => {
            const _onChange = ({ handle }, o) => handle(o)
            return {
              group,
              techName: name,
              _onChange,
              onChangeField: 'onChange'
            }
          }
        },
        {
          component: AssignmentRow,
          name: 'AssignmentRow',
          isListOf: 'group.assignments',
          renderIf: ({ group, isMobile }) => !isMobile && !!group && group?.assignments?.[0]?.status !== 'assigned',
          bindings: ({ assignment, overviewTabSelectedGraph }) => ({ assignment, color: labelState(overviewTabSelectedGraph).color }),
          displayState: ({ overviewTabSelectedGraph }) => ({ color: labelState(overviewTabSelectedGraph).color })
        },
        {
          component: MobileAssignmentRow,
          name: 'AssignmentRow',
          isListOf: 'visibleAssignments',
          renderIf: ({ isMobile }) => isMobile,
          bindings: ({ visibleAssignment, name, image }) => ({ assignment: visibleAssignment, name, image }),
        }
      ]
    },
    {
      component: wrap(TextButton, FlexCenterJustifyCenterWrapper),
      name: 'LoadMore',
      renderIf: ({ visibleAssignments, group, isMobile }) => !!group && group.assignments.length > 0 && visibleAssignments.length < group.assignments.length && isMobile,
      displayValue: ({ }) => 'Load more...',
      bindings: ({ group, visibleAssignments }) => ({ group, visibleAssignments })
    }
  ]
}

export default ContainerComponent(definition);
